import imageClassCalendarEN from '@/assets/img_calendar_EN.png';
import imageClassCalendarPt from '@/assets/img_calendar_PT.png';
import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import React from 'react';
import Modal from 'react-bootstrap/esm/Modal';
import { useSelector } from 'react-redux';
import './style.scss';

interface Props {
    visible: boolean;
    onHide: CallableFunction;
}

const ClassPeriodModal: React.FC<Props> = ({ visible, onHide }: Props) => {
    const { strings } = useSelector((state: ApplicationState) => ({ strings: state.locale.data }));

    const getImage = React.useMemo(() => (strings._LANGUAGE === Constants.language.PT ? imageClassCalendarPt : imageClassCalendarEN), [
        strings._LANGUAGE,
    ]);

    return (
        <Modal backdrop={'static'} centered dialogClassName="class-period-modal" onHide={onHide} show={visible}>
            <button className="modal-class__button" onClick={() => onHide()}>
                <i className="material-icons-outlined modal-class__button__icon">{Constants.icons.CLOSE}</i>
            </button>
            <div className="modal-class">
                <div className="container-top">
                    <p className="container-top__title">{strings.WORKSHOP_UNDERSTAND_DEADLINES}</p>
                </div>
                <div className="container-top__sub-title">
                    <span dangerouslySetInnerHTML={{ __html: strings.DETERMINE_THE_CLASS_PERIOD }}></span>
                </div>

                <div className="container-img">
                    <img alt="" className="container-img__img-calendar" src={getImage} />
                </div>

                <div className="container-top__footer">
                    <span dangerouslySetInnerHTML={{ __html: strings.WORKSHOP_MODAL_CALENDAR }}></span>
                </div>
            </div>
        </Modal>
    );
};

export default ClassPeriodModal;
